import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { VehicleTypeTons } from '../vehicle-type-tons/vehicle-type-tons';
FieldBuilder.setNamespace('Controlling');

export const CORRIDORTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.CorridorType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.CorridorType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const CORRIDORTYPE_CONFIG = {
  entityName: 'CorridorType',
  localizationKey: 'Controlling::Entity.CorridorType',
  fields: CORRIDORTYPE_FIELDS,
  permission: 'ControllingLiquidations.CorridorTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'VehicleTypeTons',
      foreignKeyField: 'corridorTypeId',
      localizationKey: 'Controlling::Entity.VehicleTypeTons',
      component: VehicleTypeTons,
    },
  ],
};
